import { ReportResult } from './reportEngine';

export interface SavedReport {
  id: string;
  timestamp: string;
  category: string;
  score: number;
  findingsCount: number;
  severity: 'high' | 'medium' | 'low' | 'info';
  manufacturer: string;
  reportData: ReportResult;
  isPro: boolean;
  reportType: 'FREE_PREVIEW' | 'PRO_REPORT';
}

const STORAGE_KEY = 'pccheckr_history';

export class HistoryService {
  static saveReport(report: SavedReport): void {
    const history = this.getHistory();
    const updatedHistory = [report, ...history];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
  }

  static getHistory(): SavedReport[] {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return [];
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error('Failed to parse history data', e);
      return [];
    }
  }

  static deleteReport(id: string): void {
    const history = this.getHistory();
    const updatedHistory = history.filter(r => r.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
  }

  static getReportById(id: string): SavedReport | undefined {
    const history = this.getHistory();
    return history.find(r => r.id === id);
  }

  static getLatestReport(): SavedReport | undefined {
    const history = this.getHistory();
    return history.length > 0 ? history[0] : undefined;
  }
}
